/* eslint-disable */
(function (window, document, $, app) {
	function initContactMap(setCoordinates, mapElement, isSingle) {
		if (!mapElement) {
			return;
		}

		const styles = [
			{
				"featureType": "landscape",
				"stylers": [{"saturation": -100}, {"lightness": 60}]
			}, {
				"featureType": "road.local",
				"stylers": [{"saturation": -100}, {"lightness": 40}, {"visibility": "on"}]
			}, {
				"featureType": "transit",
				"stylers": [{"saturation": -100}, {"visibility": "simplified"}]
			}, {"featureType": "administrative.province", "stylers": [{"visibility": "off"}]}, {
				"featureType": "water",
				"stylers": [{"visibility": "on"}, {"lightness": 30}]
			}, {
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [{"color": "#ef8c25"}, {"lightness": 40}]
			}, {
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [{"visibility": "off"}]
			}, {
				"featureType": "poi.park",
				"elementType": "geometry.fill",
				"stylers": [{"color": "#b6c54c"}, {"lightness": 40}, {"saturation": -40}]
			}, {
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#EBEBEB"
					}
				]
			}, {
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			},
			// {
			// 	"featureType": "poi.attraction",
			// 	"elementType": "labels.icon",
			// 	"stylers": [
			// 		{
			// 			"saturation": -100
			// 		}
			// 	]
			// },
			{
				"featureType": "poi.attraction",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.attraction",
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"weight": 1
					}
				]
			},
			// {
			// 	"featureType": "poi.business",
			// 	"elementType": "labels.icon",
			// 	"stylers": [
			// 		{
			// 			"saturation": -100
			// 		}
			// 	]
			// },
			{
				"featureType": "poi.business",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.business",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.government",
				"elementType": "labels.icon",
				"stylers": [
					{
						"saturation": -100
					}
				]
			},
			{
				"featureType": "poi.government",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.medical",
				"elementType": "labels.icon",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.medical",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "labels.icon",
				"stylers": [
					{
						"saturation": -100
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.place_of_worship",
				"elementType": "labels.icon",
				"stylers": [
					{
						"saturation": -100
					}
				]
			},
			{
				"featureType": "poi.place_of_worship",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.school",
				"elementType": "labels.icon",
				"stylers": [
					{
						"saturation": -100
					}
				]
			},
			{
				"featureType": "poi.school",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			},
			{
				"featureType": "poi.sports_complex",
				"elementType": "labels.icon",
				"stylers": [
					{
						"saturation": -100
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels.icon",
				"stylers": [
					{
						"color": "#6cbc78"
					}
				]
			},
			{
				"featureType": "poi.sports_complex",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#c0c0c0"
					}
				]
			}
		];

		app.maps = app.maps || {};
		let hun = {lat: 46.837649560937464, lng: 19.0447998046875};
		let coordinates;
		let map = new google.maps.Map(mapElement, {
			zoom: setCoordinates ? 15 : 8,
			center: isSingle ? setCoordinates[0] : hun,
			styles: styles
		});

		if (setCoordinates) {
			coordinates = setCoordinates;
			if (!isSingle) {
				map.bounds = new google.maps.LatLngBounds(null);
			}
		} else {
			map.bounds = new google.maps.LatLngBounds(null);
			coordinates = app.retailers;
		}
		let markers = [];


		for (let i = 0; i < coordinates.length; i++) {
			let temp = coordinates[i];

			if (typeof (temp.lat) !== "undefined" && typeof (temp.lng) !== "undefined") {
				if (!isNaN(parseFloat(temp.lat)) && !isNaN(parseFloat(temp.lng))) {
					let myLatLng = new google.maps.LatLng(parseFloat(temp.lat), parseFloat(temp.lng));
					let infoboxContent = '<h3>' + temp.name + '</h3>';
					if (temp.address.address) {
						infoboxContent += '<p>' + window.Yco.i18n.address + ': ' + temp.address.address + '</p>';
					}
					if (temp.phone) {
						infoboxContent += '<p>' + window.Yco.i18n.phone + ': ' + temp.phone + '</p>';
					}
					if (temp.email) {
						infoboxContent += '<p>' + window.Yco.i18n.email + ': ' + temp.email + '</p>';
					}
					if (temp.link) {
						infoboxContent += '<p style="font-weight:500"><a href="' + temp.link + '">' + window.Yco.i18n.view + '</a></p>';
					}
					let marker = new google.maps.Marker({
						position: myLatLng,
						map: map,
						icon: `${app.themeURL}/assets/icons/marker.svg`,
						infoboxContent: infoboxContent,
						linked_id: '#retailer-' + temp.id,
					});

					marker.addListener('click', function () {
						markers.forEach(function (item) {
							if (item.infowindow) {
								item.infowindow.close();
							}
						});

						marker.infowindow = new google.maps.InfoWindow({
							content: marker.infoboxContent
						});
						marker.infowindow.open(map, this);

						const retailers = $('[id^="retailer-"]');
						if (retailers.length) {
							$.each(retailers, function (index, item) {
								$(this).removeClass('highlight');
							});
						}

						const retailer = $(marker.linked_id);
						if (retailer.length) {
							retailer.addClass('highlight');

							const wrapper = $('.terran-retailers-scroll-wrap');
							const sizes = {
								retailer: {
									top: retailer.offset().top,
									height: retailer.outerHeight()
								},
								scrollWrapper: {
									top: wrapper.offset().top,
									scrollTop: wrapper.scrollTop()
								},
								window: {
									height: $(window).height()
								}
							};

							let scrollBy = sizes.scrollWrapper.scrollTop;

							if (sizes.retailer.top < sizes.scrollWrapper.top) {
								scrollBy += sizes.retailer.top - sizes.scrollWrapper.top;
							} else if (sizes.retailer.top + sizes.retailer.height > sizes.window.height) {
								scrollBy += sizes.retailer.top + sizes.retailer.height - sizes.window.height;
							}

							wrapper.animate({
								scrollTop: scrollBy
							}, 500);
						}
					});

					if (!isSingle) {
						map.bounds.extend(myLatLng);
					}
					markers.push(marker);
				}

			}
		}
		if (!isSingle) {
			map.fitBounds(map.bounds);

			const markerCluster = new MarkerClusterer(map, markers, {
				imagePath: `${app.themeURL}/assets/icons/clusters/cluster`,

			});
			const styles = markerCluster.getStyles();
			for (let i=0; i<styles.length; i++) {
				styles[i].textColor = "white";
				styles[i].textSize = 16;
				styles[i].width = 47;
				styles[i].height = 47;

			}
		}
		let zoomListener = google.maps.event.addListener(map, "idle", function () {
			if (map.getZoom() > 18) {
				map.setZoom(18);
			}
			google.maps.event.removeListener(zoomListener);
		});
	}

	$(() => {
		app.initContactMap = initContactMap;
		const singleRetailersMap = document.querySelector('#single-retailer-map');
		const retailersMap = document.querySelector('#main_retailers_map');
		let setCoordinates,
			mapElement,
			isSingle = false;
		if (singleRetailersMap) {
			isSingle = true;
			mapElement = singleRetailersMap;
			console.log($(singleRetailersMap));
			setCoordinates = [{
				link: $(singleRetailersMap).data('link'),
				name: $(singleRetailersMap).data('name'),
				address: $(singleRetailersMap).data('address'),
				phone: $(singleRetailersMap).data('phone'),
				email: $(singleRetailersMap).data('email'),
				lat: $(singleRetailersMap).data('coord-x'),
				lng: $(singleRetailersMap).data('coord-y')
			}];
			console.log(setCoordinates);
		} else {
			mapElement = retailersMap;
		}
		initContactMap(setCoordinates, mapElement, isSingle);
	});
})
(window, document, jQuery, Yco);
/* eslint-enable */



// WEBPACK FOOTER //
// ./assets/scripts/retailers.js